// libs
import styled from 'styled-components'
// themes
import colors from 'themes/colors'

const Wrapper = styled.div`
  padding: 15px;
`

const InnerWrapper = styled.div<{ $isReview: boolean }>`
  background-color: ${colors.gray200};
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.2),
    0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 3px;
  cursor: ${({ $isReview }) => ($isReview ? 'initial' : 'pointer')};
  display: flex;
  flex-wrap: wrap;
  margin: 16px 0;
  min-height: 96px;
  padding: 16px;
  position: relative;
`

const PlanTitle = styled.div`
  color: ${colors.blue500};
  font-weight: bold;
  width: 100%;
`

const PlanInfo = styled.div`
  color: ${colors.gray850};
  width: 100%;
`

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: inherit;
`

const Title = styled.span`
  margin: 0 10px;
  font-weight: bold;
`

const DecorativeElement = styled.div`
  border-bottom: 1px solid gray;
  flex: 1;
  height: 10px;
`

export { Wrapper, InnerWrapper, PlanTitle, PlanInfo, TitleWrapper, Title, DecorativeElement }
